import { updateRestaurant } from "../graphql/mutations";
import { API, graphqlOperation } from "aws-amplify";
import { DEFAULT_SELECTION } from "../constants";

export const updateSetting = async (settings, restaurantId) => {
  try {
    const inputRestaurant = {
      id: restaurantId,
      displayDate: settings.displayDate,
      displayLogo: settings.displayLogo,
      displayCurrencySymbol: settings.displayCurrencySymbol,
      introduction: settings.introduction,
      logoKey: settings.logoKey,
      backgroundImageKey: settings.backgroundImageKey,
      displayBackground: settings.displayBackground,
      displayLogoInQRCode: settings.displayLogoInQRCode,
      restaurantName: settings.restaurantName,
      dateText: settings.dateText,
      descriptionText: settings.descriptionText,
    };
    await API.graphql(
      graphqlOperation(updateRestaurant, { input: inputRestaurant })
    );
  } catch (err) {
    console.log("error updating menu setting:", err);
  }
};

export const createDefaultMenuSetting = () => {
  return {
    displayDate: false,
    displayLogo: false,
    displayCurrencySymbol: true,
    introduction: undefined,
    logoKey: null,
    headerOne: {
      font: DEFAULT_SELECTION.font,
      color: DEFAULT_SELECTION.quaternary,
      textstyle: [],
      format: "woff",
    },
    headerTwo: {
      font: DEFAULT_SELECTION.font,
      color: DEFAULT_SELECTION.primaryColor,
      textstyle: [],
      format: "woff",
    },
    headerThree: {
      font: DEFAULT_SELECTION.font,
      color: DEFAULT_SELECTION.primaryColor,
      textstyle: [],
      format: "woff",
    },
    headerFour: {
      font: DEFAULT_SELECTION.font,
      color: DEFAULT_SELECTION.primaryColor,
      textstyle: [],
      format: "woff",
    },
    normalText: {
      font: DEFAULT_SELECTION.font,
      color: DEFAULT_SELECTION.primaryColor,
      textstyle: [],
      format: "woff",
    },
    subtext: {
      font: DEFAULT_SELECTION.font,
      color: DEFAULT_SELECTION.tertiaryColor,
      textstyle: [],
      format: "woff",
    },
  };
};
